import React from "react";
import styles from "./index.module.scss";
import CallingPipelineHeader from "../../stories/common/calling-pipeline-header";
import CallingPipelineListing from "./calling-pipeline-listing/index";

export default function CallingPipeline() {
  return (
    <div className={styles.investorList}>
      <CallingPipelineHeader />
      <CallingPipelineListing />
    </div>
  );
}
